import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MapService } from '../../services';
import { GeocoderResponse } from '../../interfaces/geocoder-response.model';
import { GoogleMapsAPIWrapper } from '@agm/core';
import { QuoteAddressDTO } from '../../interfaces/quote-address';

@Component({
  selector: 'app-google-map-dragdrop',
  templateUrl: 'google-map-dragdrop.component.html',
  styleUrls: ['google-map-dragdrop.component.scss'],
})
export class GoogleMapDragDropComponent implements OnInit {
  private _lat: number;
  @Input('lat')
  public set lat(value: number) {
    this._lat = value;
    this.markerLat = value;
    this.originalLat = this.lat;
  }
  get lat(): number {
    return this._lat;
  }

  private _lng: number;
  @Input('lng')
  public set lng(value: number) {
    this._lng = value;
    this.markerLng = value;
    this.originalLng = this.lng;
  }
  get lng(): number {
    return this._lng;
  }

  @Input('restrictBounds') restrictBounds: number;

  @Output() addressChange = new EventEmitter<{}>();

  private geocoderWorking: boolean;

  @ViewChild(GoogleMapsAPIWrapper) map: GoogleMapsAPIWrapper;
  private startLat: number;
  private startLng: number;
  markerLat: any;
  markerLng: any;
  private originalLat: number;
  private originalLng: number;

  constructor(private mapService: MapService) {}

  ngOnInit() {}

  onMapDragEnd(event) {
    const point: google.maps.LatLngLiteral = {
      lat: event.coords.lat,
      lng: event.coords.lng,
    };

    this.markerLat = point.lat;
    this.markerLng = point.lng;

    if (
      Math.abs(this.originalLat - point.lat) > this.restrictBounds ||
      Math.abs(this.originalLng - point.lng) > this.restrictBounds
    ) {
      this.map.getNativeMap().then((map) => {
        this.markerLat = this.originalLat;
        this.markerLng = this.originalLng;

        const reset: google.maps.LatLngLiteral = {
          lat: this.originalLat,
          lng: this.originalLng,
        };

        map.setCenter(reset);
        map.setZoom(15);

        // Raise a dialog message to say it's been moved to far
        console.log('Moved too far');
      });

      return;
    }

    this.setAddress(point);
  }

  setAddress(point) {
    this.lat = point.lat;
    this.lng = point.lng;

    this.mapService
      .geocodeLatLng(point)
      .then((response: GeocoderResponse) => {
        if (response.status === 'OK') {
          if (response.results.length) {
            const value = response.results[0];
            console.log('ADDRESS ', response);

            this.addressChange.emit({
              address: value.formatted_address,
              lat: point.lat,
              lng: point.lng,
            });
          }
        }
      })
      .finally(() => {
        this.geocoderWorking = false;
      });
  }
}
